var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['flex-col flex-1 lg:absolute lg:top-24 lg:right-0 bottom-0 lg:!flex overflow-y-auto lg:w-[600px]',
             _vm.showOnMobile ? '' : 'hidden',
             _vm.isDesktop.value ? '' : 'app-height'
    ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }